import { EventEmitter, InjectionToken, QueryList } from '@angular/core';
import { GridColumnComponent } from '@assetaccountant/core/components/grid/grid-column/grid-column.component';
import {
  GridRowGroup,
  GridRowNode,
} from '@assetaccountant/core/components/grid/grid-table/grid-table.component';
import { Observable } from 'rxjs';

export const GRID_ROW_DATA = new InjectionToken<GridRowDataProvider<any>>('GRID_ROW_DATA');

export interface GetRowDataParams<T extends {}> {
  top: number;
  columns: QueryList<GridColumnComponent<T, any>>;
  parent: GridRowGroup<T> | null;
}

export interface GetRowDataResult<T extends {}> {
  rows: ReadonlyArray<GridRowNode<T>>;
  count: number | null;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GridRowDataProvider<T extends {}> {
  refresh: EventEmitter<{ purge: boolean }>;
  getRowData(params: GetRowDataParams<T>): Observable<GetRowDataResult<T>>;
  bucketSize?: number;

  readonly infiniteScroll: boolean;
}
